import { create } from "zustand";
import { getReviewItemsCountApi } from "@/portals/patient/api/reviewItemsApi";

interface ReviewItemsCountState {
  /** Open medication review items awaiting the viewed profile's input. */
  awaitingInput: number;
  /** Re-reads the count for the given profile (undefined = the patient's own). */
  refresh: (actingAsProfileId?: string) => Promise<void>;
}

// Bumped per request so a slow response for a profile the patient already
// switched away from can't overwrite the newer profile's count.
let requestSeq = 0;

export const useReviewItemsCountStore = create<ReviewItemsCountState>((set) => ({
  awaitingInput: 0,
  refresh: async (actingAsProfileId) => {
    const seq = ++requestSeq;
    const { data } = await getReviewItemsCountApi(actingAsProfileId);
    if (seq !== requestSeq) return;
    // A failed read keeps the last known value rather than flashing the badge away.
    if (data) set({ awaitingInput: Math.max(0, data.awaitingInput) });
  },
}));
